<template>
  <v-container class="system-user-page" fluid tag="section">
    <base-material-table
      :item="item"
      ref="table"
      @on-add='addModal = { show: true, type: 1 }'
      single-expand
      :excel='excel'
      >
      <template v-slot:condition>
        <v-col cols="12" md='2' class="pr-2 pb-0 pt-c-10 px-0" v-if="!$isMobile">
          <v-select
            :items="[{ text: 'Version_1.0', value: 1 },{ text: 'Version_2.0', value: 2 }]"
            label="专利版本"
            v-model="item.params.version"
            hide-details='auto'
            outlined dense
            clearable
            @change="loadData"
            clear-icon="mdi-close-circle-outline"
          ></v-select>
        </v-col>
        <v-col cols="12" md='2' class="pr-2 pb-n1 pt-c-10 px-0">
          <base-marerial-user-select  @on-change="loadData" label='业务负责人' hide-details outlined dense v-model="item.params.userIds" mid :menu='$constants.SysMenu.PARTENT_LIST_M_ID'></base-marerial-user-select>
        </v-col>
        <v-col cols="12" md='2' class="pr-2 pb-n1 pt-c-10 px-0" v-if="!$isMobile">
          <base-marerial-user-select :other-users="otherUsers"  @on-change="loadData" label='撰写人' hide-details outlined dense v-model="item.params.writerIds" :menu='$constants.SysMenu.PARTENT_LIST_M_ID'></base-marerial-user-select>
        </v-col>
      </template>
      <template v-slot:expanded-content="{ headers, item, refresh }">
          <div v-if='$isMobile && refresh'>
            <v-divider></v-divider>
            <detail-view :item='item' show-arrows @on-load-data='loadData'></detail-view>
          </div>
          <td :colspan="headers.length" v-else-if='refresh' class="px-0">
            <detail-view :item='item'  @on-load-data='loadData'></detail-view>
          </td>
      </template>
    </base-material-table>
    <dist-view :item='distModal' @on-load-data='loadData'></dist-view>
    <edit-view :item='editModal' @on-load-data='loadData'></edit-view>
    <archives-edit :item='archivesEditModal' @on-load-data='loadData'></archives-edit>
    <add-out :item='addModal' @on-load-data='loadData'></add-out>
    <cert-view :item='certModal' @on-load-data='loadData'></cert-view>
    <receive-view :item='receiveModal' @on-load-data='loadData'></receive-view>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="warning">mdi-alert</v-icon>&nbsp;
          系统提示
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <div class="text-h6 pa-2 px-0">
              确定{{isDelete}}此专利吗？
            </div>
            <v-row>
              <v-col cols="12">
                <v-textarea rows='3' label="备注信息" hide-details='auto' filled rounded  dense :rules="required" v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end p4-1">
          <v-btn text small color="blue" @click="dialog = false">取消</v-btn>
          <v-btn color="primary" :loading="loading" depressed small @click="save">
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/patent/index.js'
  import { join } from '@/api/patent/sale.js'
  import DistView from './components/Distribution.vue'
  import EditView from './components/Edit.vue'
  import AddOut from './components/AddOut.vue'
  import CertView from './components/Cert.vue'
  import ReceiveView from './components/Receive.vue'
  import DetailView from './Detail.vue'
  import ArchivesEdit from './Edit.vue'

  export default {
    components: {
      AddOut,
      DistView,
      EditView,
      CertView,
      DetailView,
      ReceiveView,
      ArchivesEdit
    },
    name: 'PatentIndex',
    data() {
      return {
        tab: 0,
        addModal: { show: false, data: {} },
        distModal: { show: false, data: {} },
        editModal: { show: false, data: {} },
        certModal: { show: false, data: {} },
        receiveModal: { show: false, data: {} },
        archivesEditModal: { show: false, data: {} },
        otherUsers: [
          { id: 89, mdUserId: 'cedd0c5c18c6ce4c76a9709b21d7b020', nameDeptStr: '明邦(外部公司)', name: '明邦' },
          { id: 90, mdUserId: 'f7a86d38009c3b7a3bc31042027d14db', nameDeptStr: '阆苑双诚(外部公司)', name: '阆苑双诚' },
          { id: 91, mdUserId: '244421ddf44629b66ea34bb2c20b9cb4', nameDeptStr: '成为(外部公司)', name: '成为' },
          { id: 92, mdUserId: '133421ddf44629b66ea34bb2c20b9cb4', nameDeptStr: '冠胜(外部公司)', name: '冠胜' },
          { id: 93, mdUserId: '41003ddf44629b66ea34bb2c20b9cb4a', nameDeptStr: '水载舟(外部公司)', name: '水载舟' },
          { id: 94, mdUserId: 'd9699173357bf2ad2057ed3b09bffd48', nameDeptStr: '大象事务所(外部公司)', name: '大象事务所' },
          { id: 95, mdUserId: 'd29c7ef830a8ab04b537015d8a3f0b1b', nameDeptStr: '安徽新知汇(外部公司)', name: '安徽新知汇' },
          { id: 96, mdUserId: '7aee9958e979ce08e1c0f58610058dbc', nameDeptStr: '北京研展(外部公司)', name: '北京研展' },
          { id: 97, mdUserId: '22003ddf44629b66ea34bb2c20b9cb4f', nameDeptStr: '明礼(外部公司)', name: '明礼' },
          { id: 98, mdUserId: '28003ddf44629b66ea34bb2c20b9cb4f', nameDeptStr: '友航(外部公司)', name: '友航' },
          { id: 99, mdUserId: '28003ddf44629b66ea34bb2c20b9cb4a', nameDeptStr: '睿禾(外部公司)', name: '睿禾' }
        ],
        loading: false,
        dialog: false,
        isDelete: '作废',
        form: { remark: '' },
        required: [
          value => !!value || '此项为必填项!'
        ],
        item: {
          mobile: true,
          path: 'patent/info/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'add', show: this.$_has('patent-info-add') },
            { event: 'download', show: this.$_has('patent-info-down') }
          ],
          params: {
            listType: 1,
            userIds: []
          },
          sort: {
            orderByField: 'create_time',
            asc: false
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.table.showMore(row, idx)
                }
              }
            },
            {
              text: '企业名称',
              align: 'center',
              divider: true,
              value: 'customerName',
              sortable: false,
              width: 200,
              copy: true,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '申请人名称',
              align: 'center',
              divider: true,
              value: 'applyUser',
              sortable: false,
              width: 200,
              copy: true,
              mobile: true,
              formatter: (val) => val || '--',
              search: { type: 'input', mobile: true }
            },
            {
              text: '专利名称',
              align: 'center',
              divider: true,
              value: 'name',
              sortable: true,
              width: 220,
              copy: true,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '受理时间',
              align: 'center',
              divider: true,
              value: 'acceptTime',
              sortable: false,
              width: 120,
              mobile: true,
              search: {
                type: 'date',
                secKey: 'acceptTimes',
                range: true,
                label: '受理时间',
                multiple: true
              },
              formatter: (val) => !val ? '--' : this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '专利编号',
              align: 'center',
              divider: true,
              value: 'patentCode',
              sortable: false,
              width: 170,
              copy: true,
              mobile: true,
              formatter: (val) => val || '--',
              search: { type: 'input', mobile: true }
            },
            {
              text: '专利类型',
              align: 'center',
              divider: true,
              value: 'patentType',
              sortable: false,
              mobile: true,
              width: 140,
              chip: {
                color: (val) => (val === 1 ? 'success' : val === 2 ? 'cyan' : 'blue'),
                formatter: (val) => (val === 1 ? '实用新型' : val === 2 ? '发明专利' : '外观专利')
              },
              search: {
                type: 'select',
                secKey: 'patentType',
                options: () => [
                  { label: '实用新型', value: 1 },
                  { label: '发明专利', value: 2 },
                  { label: '外观专利', value: 3 }
                ]
              }
            },
            {
              text: '授权发文',
              align: 'center',
              divider: true,
              value: 'authTime',
              sortable: false,
              width: 120,
              mobile: true,
              formatter: (val) => !val ? '--' : this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '流程状态',
              align: 'center',
              divider: true,
              value: 'statusVal',
              sortable: false,
              width: 120,
              mobile: true,
              search: {
                type: 'select',
                secKey: 'status',
                multiple: true,
                options: () => [
                  { label: '已放弃', value: 0 },
                  { label: '待分配', value: 1 },
                  { label: '待撰写', value: 5 },
                  { label: '待审核', value: 10 },
                  { label: '待提交流程', value: 15 },
                  { label: '待提交CPC', value: 20 },
                  { label: '已提交CPC', value: 21 },
                  { label: '受理通过', value: 25 },
                  { label: '受理驳回', value: 27 },
                  { label: '专利撤回', value: 28 },
                  { label: '授权发文', value: 30 },
                  { label: '审查补正', value: 31 },
                  { label: '授权驳回', value: 32 },
                  { label: '已下证书', value: 35 },
                  { label: '已领证书', value: 36 },
                  { label: '只写不提交', value: 16 }
                ]
              }
            },
            {
              text: '费减',
              align: 'center',
              divider: true,
              value: 'thisReduction',
              sortable: false,
              mobile: true,
              width: 100,
              formatter: (val) => (val === 1 ? '已做' : val === 2 ? '不做' : '未做')
            },
            {
              text: '业务负责人',
              align: 'center',
              divider: true,
              value: 'signUser',
              sortable: false,
              width: 140,
              mobile: true,
              formatter: (val, item) => {
                let name = ''
                if (item.contract) {
                  item.contract.contactsPersonList.forEach(i => {
                    name += `${i.name}|`
                  })
                }
                return name ? name.substring(0, name.lastIndexOf("|")) : val ? val.name : ''
              }
            },
            {
              text: '代理人',
              align: 'center',
              divider: true,
              value: 'agenter',
              sortable: false,
              mobile: true,
              width: 120
            },
            {
              text: '费用负责人',
              align: 'center',
              divider: true,
              value: 'operateUser',
              sortable: false,
              mobile: true,
              width: 150,
              formatter: (val) => (!val ? '--' : val.name)
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              divider: true,
              width: 120,
              sortable: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '更新时间',
              align: 'center',
              value: 'updateTime',
              divider: true,
              width: 120,
              sortable: true,
              formatter: (val) => val ? this.$moment(val * 1000).format('YYYY-MM-DD') : '--'
            },
            {
              text: '外派时间',
              align: 'center',
              value: 'outWriteTimeStr',
              width: 120,
              sortable: true,
              mobile: true,
              formatter: (val) => val || '--',
              search: {
                type: 'date',
                secKey: 'outWriteTimes',
                range: true,
                label: '外派时间(针对外派项目)',
                multiple: true
              },
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              sortable: false,
              width: 120,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              menu: {
                text: '操作',
                color: 'primary',
                icon: 'mdi-menu-down-outline',
                actions: [
                  {
                    text: '编辑',
                    color: 'blue',
                    icon: 'mdi-pencil',
                    onClick: (row) => {
                      this.edit(row)
                    },
                    disable: (row) => row.status === 30 || row.status === 0 || row.status === 27 || row.status === 32 || row.status === 28 || !this.$_has('patent-info-edit')
                  },
                  {
                    text: '续报',
                    color: 'green',
                    icon: 'mdi-arrow-u-up-right-bold',
                    onClick: (row) => {
                      this.editModal = { show: true, data: row, add: true }
                    },
                    disable: (row) => (row.status !== 27 && row.status !== 32 && row.status !== 28) || !this.$_has('patent-info-resubmit')
                  },
                  {
                    text: '分配',
                    color: 'green',
                    icon: 'mdi-account',
                    onClick: (row) => {
                      this.dist(row)
                    },
                    disable: (row) => row.status === 30 || row.status === 0 || row.status === 27 || row.status === 32 || row.status === 28 || !this.$_has('patent-info-dist')
                  },
                  {
                    text: '出售',
                    color: 'deep-green',
                    icon: 'mdi-cart-percent',
                    onClick: (row) => {
                      this.sale(row)
                    },
                    disable: (row) => (row.status !== 30 && row.status !== 35 && row.status !== 36) || !this.$_has('patent-sale-save')
                  },
                  {
                    text: '作废',
                    color: 'deep-orange',
                    icon: 'mdi-trash-can-outline',
                    onClick: (row) => {
                      this.dialog = true
                      this.isDelete = '作废'
                      this.form.id = row.id
                      this.form.status = 0
                    },
                    disable: (row) => (row.status !== 30 && row.status !== 35 && row.status !== 36) || !this.$_has('patent-info-delete')
                  },
                  {
                    text: '重新监控',
                    color: 'green',
                    icon: 'mdi-certificate',
                    onClick: (row) => {
                      this.dialog = true
                      this.isDelete = '重新监控'
                      this.form.id = row.id
                      this.form.status = 35
                    },
                    disable: (row) => row.status !== 0 || !this.$_has('patent-info-delete')
                  },
                  {
                    text: '授权公告',
                    color: 'brown',
                    icon: 'mdi-certificate',
                    onClick: (row) => {
                      this.certModal = { show: true, data: row }
                    },
                    disable: (row) => row.status !== 30
                  },
                  {
                    text: '档案修正',
                    color: 'blue',
                    icon: 'mdi-book-check',
                    onClick: (row) => {
                      this.archivesEditModal = { show: true, data: row }
                    },
                    disable: (row) => row.status < 25 || row.status === 28 || row.status === 32 || !this.$_has('patent-info-edit')
                  },
                ]
              }
            }
          ]
        },
        excel: {
          path: '/patent/info/down',
          filename: '专利导出列表.xls',
          header: '专利名单',
          fields: {
            客户名称: 'customerName',
            申请人名称: 'applyUser',
            专利名称: 'name',
            专利类型: {
              field: 'patentType',
              callback: (val) => (val === 1 || val === 3 ? '实用新型/外观' : '发明')
            },
            业务负责人: 'busPersion',
            专利号: {
              field: 'patentCode',
              callback: (val) => val ? `${val}*` : '--'
            },
            受理时间: {
              field: 'acceptTime',
              callback: (val) => val ? this.$moment(val * 1000).format('YYYY-MM-DD') : '--'
            },
            授权发文: {
              field: 'authTime',
              callback: (val) => val ? this.$moment(val * 1000).format('YYYY-MM-DD') : '--'
            },
            流程状态: 'statusVal',
            代理人: 'agenter'
          }
        }
      }
    },
    methods: {
      detail (item) {
        this.detailModal = { show: true, data: item }
      },
      dist (item) {
        this.distModal = { show: true, data: item }
      },
      edit (item) {
        this.editModal = { show: true, data: item }
      },
      loadData () {
        this.$refs.table.loadData()
      },
      sale (row) {
        this.$dialog.confirm({
          text: `确认出售【${row.name}】吗?`,
          title: '系统提示',
          width: 300,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                join({ patentId: row.id }).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success(`操作成功`, { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      },
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.dialog = false
              this.loadData()
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      }
    }
  }
</script>

<style lang="sass">
  .system-user-page
</style>
